module.exports = __webpack_public_path__ + "img/lefteris-kallergis-etWlaoFnTl4-unsplash.7e105725.jpg";